import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper } from './style'
import { ConfigProvider, message, Pagination, Table } from 'antd';
import SpApi from './lib/spApi'
import AmazonAdvertising from './lib/amazonAdvertising'
import { Link, useSearchParams } from 'react-router-dom';
import { MakeApiCall } from '../../../../apis';
import {Helmet} from "react-helmet";
import { useCanEdit } from '../../../../contexts/SubUserAccessContext';
import { getCredentialStatus, getSpModalConnectPrompt, getAdsModalConnectPrompt } from './lib/connectPrompt';
import { MarketplaceProgressStrip } from './lib/MarketplaceConnectPrompt';

function MarketplaceCredentials({userData}) {
  const canEdit = useCanEdit();
  const [searchParams, setSearchParams] = useSearchParams();

  // Default to spApi if tab is not present in URL
  const tabFromUrl = searchParams.get("tab") || "spApi";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [spApiList, setSpApiList] = useState([]);
  const [advertisingList, setAdvertisingList] = useState([]);

  const fetchUserCredentials = async () => {
    setLoading(true);
    try {
      const response = await MakeApiCall(
          'user-credentials',
          'get',
          null,
          true,
          {},
          userData?.token
      );

      if (response?.status) {
        const records = response?.data?.records || {};
        setTotalPage(response?.data?.pagination?.totalCount || 0);
        setPage(response?.data?.pagination?.page || 1);
        setSpApiList(records['SP-API'] || []);
        setAdvertisingList(records['Advertising-API'] || []);
        return records; // return records so callers (children) can use the fresh data without another API call
      } else {
        message.warning(response?.message);
        setSpApiList([]);
        setAdvertisingList([]);
        return null;
      }
    } catch (error) {
      message.error('Error fetching credentials.');
      setSpApiList([]);
      setAdvertisingList([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserCredentials();
  }, [page, pageSize]);

  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  const { hasSpOAuthCallback, hasAdsOAuthCallback } = useMemo(() => {
    const url = new URL(window.location.href);
    return {
      hasSpOAuthCallback: !!(
        url.searchParams.get("spapi_oauth_code") &&
        url.searchParams.get("selling_partner_id")
      ),
      hasAdsOAuthCallback: !!(
        url.searchParams.get("code") &&
        url.searchParams.get("scope")
      ),
    };
  }, []);

  const shouldAutoOpenSpConnect =
    !loading &&
    canEdit &&
    spApiList.length === 0 &&
    !hasSpOAuthCallback;

  const shouldAutoOpenAdsConnect =
    !loading &&
    canEdit &&
    spApiList.length > 0 &&
    advertisingList.length === 0 &&
    !hasAdsOAuthCallback;

  const credentialStatus = useMemo(
    () => getCredentialStatus(spApiList.length, advertisingList.length),
    [spApiList.length, advertisingList.length]
  );

  const spModalConnectPrompt = useMemo(
    () => getSpModalConnectPrompt(credentialStatus),
    [credentialStatus]
  );

  const adsModalConnectPrompt = useMemo(
    () => getAdsModalConnectPrompt(credentialStatus),
    [credentialStatus]
  );

  const showProgressStrip = !loading && credentialStatus !== "complete";

  const connectedCount =
    (spApiList.length > 0 ? 1 : 0) + (advertisingList.length > 0 ? 1 : 0);

  return (
      <Wrapper>
        <Helmet><title>Marketplace credentials</title></Helmet>
        {/* <div class="mb-10 mx-md-n9 mx-n2 px-10 py-5 bg-white filter">
          <div class="position-relative ">
            <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 d-inline-flex">
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'spApi' ? 'active' : ''}`}
                    onClick={() => handleTabChange('spApi')}
                >
                  Seller Central
                </Link>
              </li>
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'advertising' ? 'active' : ''}`}
                    onClick={() => handleTabChange('advertising')}
                >
                  Campaign Manager
                </Link>
              </li>
            </ul>
          </div>
        </div> */}

        {/* {activeTab === 'spApi' && <SpApi list={spApiList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>} */}
        {/* {activeTab === 'advertising' && <AmazonAdvertising list={advertisingList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>} */}
        <div className='mt-10'>
          {showProgressStrip && (
            <MarketplaceProgressStrip
              hasSp={spApiList.length > 0}
              hasAds={advertisingList.length > 0}
              connectedCount={connectedCount}
            />
          )}

          <SpApi
            list={spApiList}
            loading={loading}
            userData={userData}
            fetchList={fetchUserCredentials}
            shouldAutoOpenConnect={shouldAutoOpenSpConnect}
            modalConnectPrompt={spModalConnectPrompt}
          />
          <AmazonAdvertising
            list={advertisingList}
            loading={loading}
            userData={userData}
            fetchList={fetchUserCredentials}
            shouldAutoOpenConnect={shouldAutoOpenAdsConnect}
            modalConnectPrompt={adsModalConnectPrompt}
          />
        
        </div>
        
      </Wrapper>
  )
}

export default MarketplaceCredentials